// extracted by mini-css-extract-plugin
module.exports = {"bb-publication-author":"bb-publication-author__EjpwJ"};